module.exports = {
  "$id": "deregistration",
  "type": "object",
  "title": "校验密码",
  "properties": {
    "checkPassword": {
      "title": "密码",
      "type": "string",
      "format": "password"
    }
  },
  "required": [
    "checkPassword",
  ],
  "errorMessage": {
    "checkPassword": {
      "message": "请输入密码,8位-20位",
      "required": "密码不能为空"
    }
  }
}
